// SPDX-License-Identifier: AGPL-3.0-or-later

import {SettingsSection} from '@app/features/app/components/dialogs/shared/SettingsSection';
import {SettingsTabContainer, SettingsTabContent} from '@app/features/app/components/dialogs/shared/SettingsTabLayout';
import {DisplayTabContent} from '@app/features/user/components/modals/tabs/chat_settings_tab/DisplayTab';
import {InboxTabContent} from '@app/features/user/components/modals/tabs/chat_settings_tab/InboxTab';
import {InputTabContent} from '@app/features/user/components/modals/tabs/chat_settings_tab/InputTab';
import {InteractionTabContent} from '@app/features/user/components/modals/tabs/chat_settings_tab/InteractionTab';
import {LinksTabContent} from '@app/features/user/components/modals/tabs/chat_settings_tab/LinksTab';
import {MediaTabContent} from '@app/features/user/components/modals/tabs/chat_settings_tab/MediaTab';
import {SearchEnginesTabContent} from '@app/features/user/components/modals/tabs/chat_settings_tab/SearchEnginesTab';
import {SidebarTabContent} from '@app/features/user/components/modals/tabs/chat_settings_tab/SidebarTab';
import {useLingui} from '@lingui/react/macro';
import {observer} from 'mobx-react-lite';
import type React from 'react';

const ChatSettingsTab: React.FC = observer(() => {
	const {t} = useLingui();
	return (
		<SettingsTabContainer>
			<SettingsTabContent>
				<SettingsSection
					id="display"
					title={t`Display`}
					description={t`Control how messages, media, and other content are displayed.`}
				>
					<DisplayTabContent />
				</SettingsSection>
				<SettingsSection id="media" title={t`Media`} description={t`Customize media size preferences and buttons.`}>
					<MediaTabContent />
				</SettingsSection>
				<SettingsSection id="input" title={t`Input`} description={t`Customize message input settings.`}>
					<InputTabContent />
				</SettingsSection>
				<SettingsSection
					id="interaction"
					title={t`Interaction`}
					description={t`Configure message interaction settings.`}
				>
					<InteractionTabContent />
				</SettingsSection>
				<SettingsSection
					id="links"
					title={t`External Links`}
					description={t`Configure how external link warnings are handled.`}
				>
					<LinksTabContent />
				</SettingsSection>
				<SettingsSection
					id="search_engines"
					title={t`Search Engines`}
					description={t`Configure search engines, translators, and reverse image search providers for selected text and media.`}
				>
					<SearchEnginesTabContent />
				</SettingsSection>
				<SettingsSection
					id="sidebar"
					title={t`Sidebar`}
					description={t`Configure how the community sidebar is displayed.`}
				>
					<SidebarTabContent />
				</SettingsSection>
				<SettingsSection id="inbox" title={t`Inbox`} description={t`Configure how the inbox behaves.`}>
					<InboxTabContent />
				</SettingsSection>
			</SettingsTabContent>
		</SettingsTabContainer>
	);
});

export default ChatSettingsTab;
